var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumeric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 18,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 148,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 148,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 90,
    height: 90
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M60.179,57.142H46.553V46.537c10.236,0,15.785-3.946,16.648-11.84h11.407V92.78H60.179V57.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M186.967,67.624c2.712-1.726,4.89-3.123,6.536-4.193c1.643-1.068,2.753-1.851,3.329-2.343c3.042-2.549,4.563-5.117,4.563-7.709 c0-1.026-0.195-1.983-0.585-2.866c-0.391-0.886-0.926-1.636-1.604-2.251c-0.677-0.617-1.471-1.1-2.374-1.448 c-0.904-0.35-1.871-0.525-2.898-0.525c-6.249,0-9.373,3.926-9.373,11.776h-12.887c-0.616-6.74,1.15-12.473,5.303-17.202 c2.096-2.342,4.511-4.08,7.245-5.211c2.733-1.129,5.846-1.694,9.341-1.694c6.002,0,10.955,1.5,14.861,4.499 c4.316,3.33,6.473,7.832,6.473,13.504c0,5.139-1.562,9.393-4.686,12.762c-0.904,0.946-2.209,2.056-3.914,3.329 c-1.707,1.275-3.854,2.693-6.443,4.255c-5.18,3.084-8.839,5.898-10.976,8.448h26.761V92.78h-45.319 C170.319,82.998,175.869,74.613,186.967,67.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M85.959,204.976c0,2.877-0.545,5.479-1.633,7.799c-1.091,2.322-2.643,4.296-4.656,5.92c-2.015,1.622-4.419,2.878-7.214,3.761 c-2.796,0.883-5.899,1.324-9.31,1.324c-7.399,0-13.103-1.848-17.111-5.548c-4.009-3.7-6.011-9.127-6.011-16.277h12.887 c0,6.905,3.308,10.356,9.927,10.356c6.249,0,9.372-2.445,9.372-7.336c0-5.219-3.124-7.832-9.372-7.832 c-1.973,0-3.391,0.124-4.254,0.372v-9.929c0.247,0.082,0.688,0.124,1.326,0.124c0.638,0,1.489,0,2.559,0 c1.232,0,2.384-0.133,3.452-0.4c1.069-0.268,2.004-0.657,2.806-1.173c0.801-0.513,1.439-1.15,1.912-1.912 c0.472-0.759,0.709-1.633,0.709-2.621c0-1.848-0.883-3.349-2.651-4.5c-1.687-0.946-3.598-1.418-5.735-1.418 c-5.549,0-8.325,2.733-8.325,8.2H41.627c0-2.875,0.525-5.527,1.572-7.955c1.048-2.424,2.527-4.499,4.439-6.227 c1.912-1.726,4.214-3.072,6.906-4.039c2.692-0.965,5.682-1.447,8.972-1.447c5.589,0,10.337,1.335,14.243,4.008 c4.399,3.164,6.597,7.212,6.597,12.145c0,6.372-2.651,10.113-7.954,11.223v0.369c1.233,0.083,2.425,0.475,3.577,1.172 c1.15,0.699,2.166,1.634,3.051,2.806c0.883,1.17,1.593,2.527,2.127,4.069C85.692,201.552,85.959,203.207,85.959,204.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M210.369,223.78h-13.503v-12.887h-27.438v-13.132l27.685-32.064h13.256v33.234h7.339v11.962h-7.339V223.78z M181.328,198.931 h15.538v-18.065L181.328,198.931z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumeric);
export default __webpack_public_path__ + "static/media/numeric.f455e0b0208cb3dc8e6d6761ecbfaec6.svg";
export { ForwardRef as ReactComponent };